export default __webpack_public_path__ + "static/media/Weeds.f619a583.jpg";